import { CheckIcon } from "Icons/Check";

import { SerializedStyles, css } from "@emotion/react";

import { purple, uiGray, white } from "constants/colors";

import { FieldLabel } from "./FieldLabel";

const styles = {
  wrapper: css({
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    width: "fit-content",
  }),
  button: css({
    width: 16,
    height: 16,
    borderRadius: 2,
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  }),
  checked: css({
    background: "rgba(141, 141, 141, 0.05)",
    border: `1px solid ${purple[700]}`,
  }),
  unchecked: css({
    background: white,
    border: `1px solid ${uiGray[20]}`,
  }),
  disabled: css({
    border: `1px solid ${uiGray[20]}`,
  }),
};
type Props = {
  label: string;
  checked: boolean;
  isDisabled?: boolean;
  onChange: (value: boolean) => void;
  customCss?: { button?: SerializedStyles; label?: SerializedStyles };
  displayLabelLeft?: boolean;
  displayLabelRight?: boolean;
  isOptional?: boolean;
};

export const Checkbox = ({
  label,
  checked,
  onChange,
  customCss,
  isDisabled = false,
  displayLabelLeft = false,
  displayLabelRight = false,
  isOptional = false,
}: Props) => {
  return (
    <div
      css={styles.wrapper}
      onClick={() => {
        if (!isDisabled) onChange(!checked);
      }}
      aria-disabled={isDisabled}
    >
      {displayLabelLeft && (
        <FieldLabel
          isDisabled={isDisabled}
          label={label}
          isOptional={isOptional}
          customCss={{
            main: css({ marginBottom: 0 }),
            label: customCss?.label,
          }}
        />
      )}
      <button
        disabled={isDisabled}
        css={[
          styles.button,
          customCss,
          checked ? styles.checked : styles.unchecked,
          isDisabled ? styles.disabled : undefined,
        ]}
        aria-label={label}
        aria-checked={checked}
        role="checkbox"
        onClick={(e) => {
          onChange(!checked);
          e.stopPropagation();
        }}
      >
        {checked && (
          <CheckIcon
            width={16}
            height={16}
            stroke={isDisabled ? uiGray[50] : purple[700]}
          />
        )}
      </button>
      {displayLabelRight && (
        <FieldLabel
          isDisabled={isDisabled}
          label={label}
          isOptional={isOptional}
          customCss={{
            main: css({ marginBottom: 0 }),
            label: customCss?.label,
          }}
        />
      )}
    </div>
  );
};
